import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function RouteMatching() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 warm-sand-bg">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left: Visual */}
          <div>
            <div className="relative bg-card-50 rounded-xl p-8 border border-card-200 shadow-sm">
              {/* Route visual */}
              <div className="space-y-6">
                {/* Origin */}
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                    <i className="ri-building-2-line text-lg"></i>
                  </div>
                  <div>
                    <div className="font-heading font-bold text-primary-700 text-sm">Kochi Cold Storage Hub</div>
                    <div className="text-xs text-foreground-400">Origin Warehouse</div>
                  </div>
                </div>

                {/* Route line */}
                <div className="relative pl-6 ml-5 border-l-2 border-dashed border-secondary-300 py-2">
                  <div className="flex items-center gap-3 -ml-[29px]">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-snowflake-line text-xs"></i>
                    </div>
                    <div className="text-xs text-foreground-500">
                      620 km · Temp: -22°C maintained · ETA: 14 hours
                    </div>
                  </div>
                </div>

                {/* Destination */}
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                    <i className="ri-store-2-line text-lg"></i>
                  </div>
                  <div>
                    <div className="font-heading font-bold text-primary-700 text-sm">Bengaluru Wholesale Hub</div>
                    <div className="text-xs text-foreground-400">Destination Market</div>
                  </div>
                </div>
              </div>

              {/* Vehicle info bar */}
              <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-wrap items-center gap-4">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-truck-line text-secondary-500"></i>
                  <span>14-ton Reefer</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-user-line text-secondary-500"></i>
                  <span>Verified Transporter</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-temp-cold-line text-secondary-500"></i>
                  <span>Temperature Logged</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Description */}
          <div>
            <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
              Smart Matching
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-6 leading-tight">
              Route & Load Matching
            </h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed">
              <p>
                Freshhlock&apos;s matching engine connects available reefer capacity with produce that needs to move — taking into account route overlap, vehicle type, temperature requirements, and delivery timelines.
              </p>
              <p>
                For transporters, this means fewer empty return trips and higher utilisation. For shippers, it means competitive pricing and verified cold-chain reliability.
              </p>
              <p className="text-sm text-foreground-400">
                Every load is tracked with real-time GPS and temperature monitoring — so both sides have full visibility from pickup to delivery.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}